import { DecodedToken } from '@core/models';
import { TenantModel } from '@core/models/auth/tenant.model';
import { AuthenticateUserCommand, ResetPasswordCommand, RequestPasswordResetCommand } from '@core/services/api.service';

export class LoginAction {
  static readonly type = '[Auth] Login';

  constructor(public payload: { authenticateUserCommand: AuthenticateUserCommand, redirectUrl?: string }) { }
}

export class LoginSuccessAction {
  static readonly type = '[Auth] Login Success';

  constructor(public payload: { decodedToken: DecodedToken, redirectUrl?: string }) { }
}

export class LoginFailAction {
  static readonly type = '[Auth] Login Fail';
}

export class ClearTokenAction {
  static readonly type = '[Auth] Clear Token';
}

export class ClearLastUserAction {
  static readonly type = '[Auth] Clear Last User';
}

export class RequestForgottenPasswordAction {
  static readonly type = '[Users] Request Forgoten Password';

  constructor(public payload: { requestPasswordResetCommand: RequestPasswordResetCommand }) { }
}

export class RequestForgottenPasswordSuccessAction {
  static readonly type = '[Auth] Request Forgoten Password Success';

  constructor(public payload: { email: string }) { }
}

export class RequestForgottenPasswordFailAction {
  static readonly type = '[Auth] Request Forgoten Password Fail';
}

export class ResetForgottenPasswordAction {
  static readonly type = '[Auth] Reset Forgoten Password';

  constructor(public payload: { resetPasswordCommand: ResetPasswordCommand }) { }
}

export class ResetForgottenPasswordSuccessAction {
  static readonly type = '[Auth] Reset Forgoten Password Success';

  constructor(public payload: { username: string }) { }
}

export class ResetForgotenPasswordFailAction {
  static readonly type = '[Users] Reset Forgoten Password Fail';
}

export class ChangeTenantAction {
  static readonly type = '[Auth] Change Tenant';

  constructor(public payload: { tenant: TenantModel }) { }
}
